export function createBorders(colors) {
  var regular = {
    borderColor: colors.borderRegular,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var regularHover = {
    borderColor: colors.borderRegularHover,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var regularPressed = {
    borderColor: colors.borderRegularPressed,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var primary = {
    borderColor: colors.borderPrimary,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var primaryHover = {
    borderColor: colors.borderPrimaryHover,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var primaryPressed = {
    borderColor: colors.borderPrimaryPressed,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var secondary = {
    borderColor: colors.borderSecondary,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var secondaryHover = {
    borderColor: colors.borderSecondaryHover,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var secondaryPressed = {
    borderColor: colors.borderSecondaryPressed,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var positive = {
    borderColor: colors.borderPositive,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var positiveHover = {
    borderColor: colors.borderPositiveHover,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var positivePressed = {
    borderColor: colors.borderPositivePressed,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var warning = {
    borderColor: colors.borderWarning,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var warningHover = {
    borderColor: colors.borderWarningHover,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var warningPressed = {
    borderColor: colors.borderWarningPressed,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var negative = {
    borderColor: colors.borderNegative,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var negativeHover = {
    borderColor: colors.borderNegativeHover,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var negativePressed = {
    borderColor: colors.borderNegativePressed,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var magic = {
    borderColor: colors.borderMagic,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var magicHover = {
    borderColor: colors.borderMagicHover,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var magicPressed = {
    borderColor: colors.borderMagicPressed,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var inactive = {
    borderColor: colors.borderInactive,
    borderWidth: 1,
    borderStyle: 'solid'
  };
  var transparent = {
    borderColor: 'transparent',
    borderWidth: 1,
    borderStyle: 'solid'
  };
  return {
    regular: regular,
    regularHover: regularHover,
    regularPressed: regularPressed,
    primary: primary,
    primaryHover: primaryHover,
    primaryPressed: primaryPressed,
    secondary: secondary,
    secondaryHover: secondaryHover,
    secondaryPressed: secondaryPressed,
    positive: positive,
    positiveHover: positiveHover,
    positivePressed: positivePressed,
    warning: warning,
    warningHover: warningHover,
    warningPressed: warningPressed,
    negative: negative,
    negativeHover: negativeHover,
    negativePressed: negativePressed,
    magic: magic,
    magicHover: magicHover,
    magicPressed: magicPressed,
    transparent: transparent,
    inactive: inactive
  };
}